module.exports = {
	"v": "4.8.0",
	"meta": {
		"g": "LottieFiles AE 3.4.5",
		"a": "",
		"k": "",
		"d": "",
		"tc": ""
	},
	"fr": 30,
	"ip": 0,
	"op": 141,
	"w": 140,
	"h": 260,
	"nm": "Funnel_Spot_NoLoop_01",
	"ddd": 0,
	"assets": [],
	"layers": [
		{
			"ddd": 0,
			"ind": 1,
			"ty": 3,
			"nm": "Null 2",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 0,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						32,
						140.5,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						0,
						0,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"ip": 30,
			"op": 2730,
			"st": 30,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 2,
			"ty": 4,
			"nm": "Funnel Fill 6",
			"td": 1,
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						70,
						130,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						70,
						130,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-0.049,
											0.596
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											60.172,
											-44.235
										],
										[
											-60.194,
											-43.345
										],
										[
											-59.992,
											46.244
										],
										[
											59.948,
											45.458
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									70,
									133.012
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Funnel Shape",
					"np": 1,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "fl",
					"c": {
						"a": 0,
						"k": [
							1,
							0,
							0,
							1
						],
						"ix": 4
					},
					"o": {
						"a": 0,
						"k": 100,
						"ix": 5
					},
					"r": 1,
					"bm": 0,
					"nm": "Fill 1",
					"mn": "ADBE Vector Graphic - Fill",
					"hd": false
				}
			],
			"ip": 73,
			"op": 2874,
			"st": 73,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 3,
			"ty": 4,
			"nm": "Circle 6",
			"parent": 1,
			"tt": 2,
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": [
									0.833
								],
								"y": [
									0.833
								]
							},
							"o": {
								"x": [
									0.167
								],
								"y": [
									0.167
								]
							},
							"t": 73,
							"s": [
								0
							]
						},
						{
							"i": {
								"x": [
									0.833
								],
								"y": [
									0.833
								]
							},
							"o": {
								"x": [
									0.167
								],
								"y": [
									0.167
								]
							},
							"t": 81,
							"s": [
								0
							]
						},
						{
							"t": 101,
							"s": [
								200
							]
						}
					],
					"ix": 10
				},
				"p": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": 0.667,
								"y": 1
							},
							"o": {
								"x": 0.333,
								"y": 0
							},
							"t": 73,
							"s": [
								0,
								-123.5,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"t": 104,
							"s": [
								0,
								-98.61,
								0
							]
						}
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						0,
						0,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [
				{
					"d": 1,
					"ty": "el",
					"s": {
						"a": 0,
						"k": [
							26,
							26
						],
						"ix": 2
					},
					"p": {
						"a": 0,
						"k": [
							0,
							0
						],
						"ix": 3
					},
					"nm": "Ellipse Path 1",
					"mn": "ADBE Vector Shape - Ellipse",
					"hd": false
				},
				{
					"ty": "tm",
					"s": {
						"a": 0,
						"k": 0,
						"ix": 1
					},
					"e": {
						"a": 1,
						"k": [
							{
								"i": {
									"x": [
										0.833
									],
									"y": [
										1
									]
								},
								"o": {
									"x": [
										0.167
									],
									"y": [
										0
									]
								},
								"t": 73,
								"s": [
									0
								]
							},
							{
								"i": {
									"x": [
										0.833
									],
									"y": [
										0.833
									]
								},
								"o": {
									"x": [
										0.333
									],
									"y": [
										0
									]
								},
								"t": 81,
								"s": [
									0
								]
							},
							{
								"t": 93,
								"s": [
									100
								]
							}
						],
						"ix": 2
					},
					"o": {
						"a": 0,
						"k": 0,
						"ix": 3
					},
					"m": 1,
					"ix": 2,
					"nm": "Trim Paths 1",
					"mn": "ADBE Vector Filter - Trim",
					"hd": false
				},
				{
					"ty": "st",
					"c": {
						"a": 0,
						"k": [
							0,
							0.1882353127,
							0.341176480055,
							1
						],
						"ix": 3
					},
					"o": {
						"a": 0,
						"k": 100,
						"ix": 4
					},
					"w": {
						"a": 0,
						"k": 3,
						"ix": 5
					},
					"lc": 2,
					"lj": 2,
					"bm": 0,
					"nm": "Stroke 1",
					"mn": "ADBE Vector Graphic - Stroke",
					"hd": false
				}
			],
			"ip": 73,
			"op": 2874,
			"st": 73,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 4,
			"ty": 4,
			"nm": "Funnel Fill 3",
			"td": 1,
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						70,
						130,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						70,
						130,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-0.049,
											0.596
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											60.172,
											-44.235
										],
										[
											-60.194,
											-43.345
										],
										[
											-59.992,
											46.244
										],
										[
											59.948,
											45.458
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									70,
									133.012
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Funnel Shape",
					"np": 1,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "fl",
					"c": {
						"a": 0,
						"k": [
							1,
							0,
							0,
							1
						],
						"ix": 4
					},
					"o": {
						"a": 0,
						"k": 100,
						"ix": 5
					},
					"r": 1,
					"bm": 0,
					"nm": "Fill 1",
					"mn": "ADBE Vector Graphic - Fill",
					"hd": false
				}
			],
			"ip": 30,
			"op": 69,
			"st": 30,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 5,
			"ty": 4,
			"nm": "Circle 3",
			"parent": 1,
			"tt": 2,
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": [
									0.833
								],
								"y": [
									0.833
								]
							},
							"o": {
								"x": [
									0.167
								],
								"y": [
									0.167
								]
							},
							"t": 30,
							"s": [
								0
							]
						},
						{
							"i": {
								"x": [
									0.833
								],
								"y": [
									0.833
								]
							},
							"o": {
								"x": [
									0.167
								],
								"y": [
									0.167
								]
							},
							"t": 38,
							"s": [
								0
							]
						},
						{
							"i": {
								"x": [
									0.833
								],
								"y": [
									0.833
								]
							},
							"o": {
								"x": [
									0.167
								],
								"y": [
									0.167
								]
							},
							"t": 58,
							"s": [
								200
							]
						},
						{
							"i": {
								"x": [
									0.833
								],
								"y": [
									0.833
								]
							},
							"o": {
								"x": [
									0.167
								],
								"y": [
									0.167
								]
							},
							"t": 75,
							"s": [
								200
							]
						},
						{
							"t": 120,
							"s": [
								200
							]
						}
					],
					"ix": 10
				},
				"p": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": 0.833,
								"y": 0.833
							},
							"o": {
								"x": 0.167,
								"y": 0.167
							},
							"t": 30,
							"s": [
								0,
								-123.5,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"i": {
								"x": 0.833,
								"y": 0.833
							},
							"o": {
								"x": 1,
								"y": 0
							},
							"t": 38,
							"s": [
								0,
								-123.5,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"i": {
								"x": 0.833,
								"y": 0.833
							},
							"o": {
								"x": 0.167,
								"y": 0.167
							},
							"t": 68,
							"s": [
								0,
								-11.5,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"i": {
								"x": 0.833,
								"y": 0.833
							},
							"o": {
								"x": 0.167,
								"y": 0.167
							},
							"t": 75,
							"s": [
								0,
								-11.5,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"t": 120,
							"s": [
								0,
								-11.5,
								0
							]
						}
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						0,
						0,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [
				{
					"d": 1,
					"ty": "el",
					"s": {
						"a": 0,
						"k": [
							26,
							26
						],
						"ix": 2
					},
					"p": {
						"a": 0,
						"k": [
							0,
							0
						],
						"ix": 3
					},
					"nm": "Ellipse Path 1",
					"mn": "ADBE Vector Shape - Ellipse",
					"hd": false
				},
				{
					"ty": "tm",
					"s": {
						"a": 0,
						"k": 0,
						"ix": 1
					},
					"e": {
						"a": 1,
						"k": [
							{
								"i": {
									"x": [
										0.833
									],
									"y": [
										1
									]
								},
								"o": {
									"x": [
										0.167
									],
									"y": [
										0
									]
								},
								"t": 30,
								"s": [
									0
								]
							},
							{
								"i": {
									"x": [
										0.833
									],
									"y": [
										0.833
									]
								},
								"o": {
									"x": [
										0.333
									],
									"y": [
										0
									]
								},
								"t": 38,
								"s": [
									0
								]
							},
							{
								"i": {
									"x": [
										0.833
									],
									"y": [
										0.833
									]
								},
								"o": {
									"x": [
										0.167
									],
									"y": [
										0.167
									]
								},
								"t": 50,
								"s": [
									100
								]
							},
							{
								"i": {
									"x": [
										0.833
									],
									"y": [
										0.833
									]
								},
								"o": {
									"x": [
										0.167
									],
									"y": [
										0.167
									]
								},
								"t": 75,
								"s": [
									100
								]
							},
							{
								"t": 120,
								"s": [
									100
								]
							}
						],
						"ix": 2
					},
					"o": {
						"a": 0,
						"k": 0,
						"ix": 3
					},
					"m": 1,
					"ix": 2,
					"nm": "Trim Paths 1",
					"mn": "ADBE Vector Filter - Trim",
					"hd": false
				},
				{
					"ty": "st",
					"c": {
						"a": 0,
						"k": [
							0,
							0.1882353127,
							0.341176480055,
							1
						],
						"ix": 3
					},
					"o": {
						"a": 0,
						"k": 100,
						"ix": 4
					},
					"w": {
						"a": 0,
						"k": 3,
						"ix": 5
					},
					"lc": 2,
					"lj": 2,
					"bm": 0,
					"nm": "Stroke 1",
					"mn": "ADBE Vector Graphic - Stroke",
					"hd": false
				}
			],
			"ip": 30,
			"op": 69,
			"st": 30,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 6,
			"ty": 4,
			"nm": "Funnel Fill 5",
			"td": 1,
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						70,
						121,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						70,
						130,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-0.049,
											0.596
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											60.172,
											-44.235
										],
										[
											-60.194,
											-43.345
										],
										[
											-59.992,
											46.244
										],
										[
											59.948,
											45.458
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									70,
									133.012
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Funnel Shape",
					"np": 1,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "fl",
					"c": {
						"a": 0,
						"k": [
							1,
							0,
							0,
							1
						],
						"ix": 4
					},
					"o": {
						"a": 0,
						"k": 100,
						"ix": 5
					},
					"r": 1,
					"bm": 0,
					"nm": "Fill 1",
					"mn": "ADBE Vector Graphic - Fill",
					"hd": false
				}
			],
			"ip": 75,
			"op": 2853,
			"st": 75,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 7,
			"ty": 4,
			"nm": "Circle 5",
			"tt": 2,
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": [
									0.833
								],
								"y": [
									0.833
								]
							},
							"o": {
								"x": [
									0.167
								],
								"y": [
									0.167
								]
							},
							"t": 75,
							"s": [
								0
							]
						},
						{
							"t": 90,
							"s": [
								0
							]
						}
					],
					"ix": 10
				},
				"p": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": 0.667,
								"y": 1
							},
							"o": {
								"x": 0.333,
								"y": 0
							},
							"t": 75,
							"s": [
								105.5,
								25,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"t": 110,
							"s": [
								105.5,
								38.001,
								0
							]
						}
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						0,
						0,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [
				{
					"d": 1,
					"ty": "el",
					"s": {
						"a": 0,
						"k": [
							40,
							40
						],
						"ix": 2
					},
					"p": {
						"a": 0,
						"k": [
							0,
							0
						],
						"ix": 3
					},
					"nm": "Ellipse Path 1",
					"mn": "ADBE Vector Shape - Ellipse",
					"hd": false
				},
				{
					"ty": "tm",
					"s": {
						"a": 0,
						"k": 0,
						"ix": 1
					},
					"e": {
						"a": 1,
						"k": [
							{
								"i": {
									"x": [
										0.833
									],
									"y": [
										1
									]
								},
								"o": {
									"x": [
										0.167
									],
									"y": [
										0
									]
								},
								"t": 75,
								"s": [
									0
								]
							},
							{
								"i": {
									"x": [
										0.833
									],
									"y": [
										0.833
									]
								},
								"o": {
									"x": [
										0.333
									],
									"y": [
										0
									]
								},
								"t": 90,
								"s": [
									0
								]
							},
							{
								"t": 102,
								"s": [
									100
								]
							}
						],
						"ix": 2
					},
					"o": {
						"a": 0,
						"k": 0,
						"ix": 3
					},
					"m": 1,
					"ix": 2,
					"nm": "Trim Paths 1",
					"mn": "ADBE Vector Filter - Trim",
					"hd": false
				},
				{
					"ty": "st",
					"c": {
						"a": 0,
						"k": [
							0,
							0.1882353127,
							0.341176480055,
							1
						],
						"ix": 3
					},
					"o": {
						"a": 0,
						"k": 100,
						"ix": 4
					},
					"w": {
						"a": 0,
						"k": 3,
						"ix": 5
					},
					"lc": 2,
					"lj": 2,
					"bm": 0,
					"nm": "Stroke 1",
					"mn": "ADBE Vector Graphic - Stroke",
					"hd": false
				}
			],
			"ip": 75,
			"op": 2853,
			"st": 75,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 8,
			"ty": 4,
			"nm": "Funnel Fill 2",
			"td": 1,
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						70,
						130,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						70,
						130,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-0.049,
											0.596
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											60.172,
											-44.235
										],
										[
											-60.194,
											-43.345
										],
										[
											-59.992,
											46.244
										],
										[
											59.948,
											45.458
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									70,
									133.012
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Funnel Shape",
					"np": 1,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "fl",
					"c": {
						"a": 0,
						"k": [
							1,
							0,
							0,
							1
						],
						"ix": 4
					},
					"o": {
						"a": 0,
						"k": 100,
						"ix": 5
					},
					"r": 1,
					"bm": 0,
					"nm": "Fill 1",
					"mn": "ADBE Vector Graphic - Fill",
					"hd": false
				}
			],
			"ip": 30,
			"op": 76,
			"st": 30,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 9,
			"ty": 4,
			"nm": "Circle 2",
			"tt": 2,
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": [
									0.833
								],
								"y": [
									0.833
								]
							},
							"o": {
								"x": [
									0.167
								],
								"y": [
									0.167
								]
							},
							"t": 30,
							"s": [
								0
							]
						},
						{
							"i": {
								"x": [
									0.833
								],
								"y": [
									0.833
								]
							},
							"o": {
								"x": [
									0.167
								],
								"y": [
									0.167
								]
							},
							"t": 45,
							"s": [
								0
							]
						},
						{
							"i": {
								"x": [
									0.833
								],
								"y": [
									0.833
								]
							},
							"o": {
								"x": [
									0.167
								],
								"y": [
									0.167
								]
							},
							"t": 65,
							"s": [
								200
							]
						},
						{
							"i": {
								"x": [
									0.833
								],
								"y": [
									0.833
								]
							},
							"o": {
								"x": [
									0.167
								],
								"y": [
									0.167
								]
							},
							"t": 75,
							"s": [
								200
							]
						},
						{
							"t": 120,
							"s": [
								200
							]
						}
					],
					"ix": 10
				},
				"p": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": 0.833,
								"y": 0.833
							},
							"o": {
								"x": 0.167,
								"y": 0.167
							},
							"t": 30,
							"s": [
								105.5,
								25,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"i": {
								"x": 0.833,
								"y": 0.833
							},
							"o": {
								"x": 1,
								"y": 0
							},
							"t": 45,
							"s": [
								105.5,
								25,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"i": {
								"x": 0.833,
								"y": 0.833
							},
							"o": {
								"x": 0.167,
								"y": 0.167
							},
							"t": 75,
							"s": [
								105.5,
								124,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"t": 120,
							"s": [
								105.5,
								124,
								0
							]
						}
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						0,
						0,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [
				{
					"d": 1,
					"ty": "el",
					"s": {
						"a": 0,
						"k": [
							40,
							40
						],
						"ix": 2
					},
					"p": {
						"a": 0,
						"k": [
							0,
							0
						],
						"ix": 3
					},
					"nm": "Ellipse Path 1",
					"mn": "ADBE Vector Shape - Ellipse",
					"hd": false
				},
				{
					"ty": "tm",
					"s": {
						"a": 0,
						"k": 0,
						"ix": 1
					},
					"e": {
						"a": 1,
						"k": [
							{
								"i": {
									"x": [
										0.833
									],
									"y": [
										1
									]
								},
								"o": {
									"x": [
										0.167
									],
									"y": [
										0
									]
								},
								"t": 30,
								"s": [
									0
								]
							},
							{
								"i": {
									"x": [
										0.833
									],
									"y": [
										0.833
									]
								},
								"o": {
									"x": [
										0.333
									],
									"y": [
										0
									]
								},
								"t": 45,
								"s": [
									0
								]
							},
							{
								"i": {
									"x": [
										0.833
									],
									"y": [
										0.833
									]
								},
								"o": {
									"x": [
										0.167
									],
									"y": [
										0.167
									]
								},
								"t": 57,
								"s": [
									100
								]
							},
							{
								"i": {
									"x": [
										0.833
									],
									"y": [
										0.833
									]
								},
								"o": {
									"x": [
										0.167
									],
									"y": [
										0.167
									]
								},
								"t": 75,
								"s": [
									100
								]
							},
							{
								"t": 120,
								"s": [
									100
								]
							}
						],
						"ix": 2
					},
					"o": {
						"a": 0,
						"k": 0,
						"ix": 3
					},
					"m": 1,
					"ix": 2,
					"nm": "Trim Paths 1",
					"mn": "ADBE Vector Filter - Trim",
					"hd": false
				},
				{
					"ty": "st",
					"c": {
						"a": 0,
						"k": [
							0,
							0.1882353127,
							0.341176480055,
							1
						],
						"ix": 3
					},
					"o": {
						"a": 0,
						"k": 100,
						"ix": 4
					},
					"w": {
						"a": 0,
						"k": 3,
						"ix": 5
					},
					"lc": 2,
					"lj": 2,
					"bm": 0,
					"nm": "Stroke 1",
					"mn": "ADBE Vector Graphic - Stroke",
					"hd": false
				}
			],
			"ip": 30,
			"op": 76,
			"st": 30,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 10,
			"ty": 4,
			"nm": "Funnel Fill 4",
			"td": 1,
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						70,
						130,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						70,
						130,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-0.049,
											0.596
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											60.172,
											-44.235
										],
										[
											-60.194,
											-43.345
										],
										[
											-59.992,
											46.244
										],
										[
											59.948,
											45.458
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									70,
									133.012
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Funnel Shape",
					"np": 1,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "fl",
					"c": {
						"a": 0,
						"k": [
							1,
							0,
							0,
							1
						],
						"ix": 4
					},
					"o": {
						"a": 0,
						"k": 100,
						"ix": 5
					},
					"r": 1,
					"bm": 0,
					"nm": "Fill 1",
					"mn": "ADBE Vector Graphic - Fill",
					"hd": false
				}
			],
			"ip": 68,
			"op": 2804,
			"st": 68,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 11,
			"ty": 4,
			"nm": "Circle 4",
			"tt": 2,
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": [
									0.833
								],
								"y": [
									0.833
								]
							},
							"o": {
								"x": [
									0.167
								],
								"y": [
									0.167
								]
							},
							"t": 68,
							"s": [
								0
							]
						},
						{
							"t": 88,
							"s": [
								200
							]
						}
					],
					"ix": 10
				},
				"p": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": 0.667,
								"y": 1
							},
							"o": {
								"x": 0.8,
								"y": 0
							},
							"t": 68,
							"s": [
								70,
								27.5,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"t": 91,
							"s": [
								70,
								81.5,
								0
							]
						}
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						0,
						0,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [
				{
					"d": 1,
					"ty": "el",
					"s": {
						"a": 0,
						"k": [
							50,
							50
						],
						"ix": 2
					},
					"p": {
						"a": 0,
						"k": [
							0,
							0
						],
						"ix": 3
					},
					"nm": "Ellipse Path 1",
					"mn": "ADBE Vector Shape - Ellipse",
					"hd": false
				},
				{
					"ty": "tm",
					"s": {
						"a": 0,
						"k": 0,
						"ix": 1
					},
					"e": {
						"a": 1,
						"k": [
							{
								"i": {
									"x": [
										0.833
									],
									"y": [
										0.833
									]
								},
								"o": {
									"x": [
										0.333
									],
									"y": [
										0
									]
								},
								"t": 68,
								"s": [
									0
								]
							},
							{
								"t": 80,
								"s": [
									100
								]
							}
						],
						"ix": 2
					},
					"o": {
						"a": 0,
						"k": 0,
						"ix": 3
					},
					"m": 1,
					"ix": 2,
					"nm": "Trim Paths 1",
					"mn": "ADBE Vector Filter - Trim",
					"hd": false
				},
				{
					"ty": "st",
					"c": {
						"a": 0,
						"k": [
							0,
							0.1882353127,
							0.341176480055,
							1
						],
						"ix": 3
					},
					"o": {
						"a": 0,
						"k": 100,
						"ix": 4
					},
					"w": {
						"a": 0,
						"k": 3,
						"ix": 5
					},
					"lc": 2,
					"lj": 2,
					"bm": 0,
					"nm": "Stroke 1",
					"mn": "ADBE Vector Graphic - Stroke",
					"hd": false
				}
			],
			"ip": 68,
			"op": 2804,
			"st": 68,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 12,
			"ty": 4,
			"nm": "Funnel Fill",
			"td": 1,
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						70,
						130,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						70,
						130,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-0.049,
											0.596
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											60.172,
											-44.235
										],
										[
											-60.194,
											-43.345
										],
										[
											-59.992,
											46.244
										],
										[
											59.948,
											45.458
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									70,
									133.012
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Funnel Shape",
					"np": 1,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "fl",
					"c": {
						"a": 0,
						"k": [
							1,
							0,
							0,
							1
						],
						"ix": 4
					},
					"o": {
						"a": 0,
						"k": 100,
						"ix": 5
					},
					"r": 1,
					"bm": 0,
					"nm": "Fill 1",
					"mn": "ADBE Vector Graphic - Fill",
					"hd": false
				}
			],
			"ip": 30,
			"op": 67,
			"st": 30,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 13,
			"ty": 4,
			"nm": "Circle 1",
			"tt": 2,
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": [
									0.833
								],
								"y": [
									0.833
								]
							},
							"o": {
								"x": [
									0.167
								],
								"y": [
									0.167
								]
							},
							"t": 30,
							"s": [
								0
							]
						},
						{
							"i": {
								"x": [
									0.833
								],
								"y": [
									0.833
								]
							},
							"o": {
								"x": [
									0.167
								],
								"y": [
									0.167
								]
							},
							"t": 50,
							"s": [
								200
							]
						},
						{
							"i": {
								"x": [
									0.833
								],
								"y": [
									0.833
								]
							},
							"o": {
								"x": [
									0.167
								],
								"y": [
									0.167
								]
							},
							"t": 75,
							"s": [
								200
							]
						},
						{
							"t": 120,
							"s": [
								200
							]
						}
					],
					"ix": 10
				},
				"p": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": 0.833,
								"y": 0.833
							},
							"o": {
								"x": 0.8,
								"y": 0
							},
							"t": 30,
							"s": [
								70,
								27.5,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"i": {
								"x": 0.833,
								"y": 0.833
							},
							"o": {
								"x": 0.167,
								"y": 0.167
							},
							"t": 57,
							"s": [
								70,
								118.5,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"i": {
								"x": 0.833,
								"y": 0.833
							},
							"o": {
								"x": 0.167,
								"y": 0.167
							},
							"t": 75,
							"s": [
								70,
								118.5,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"t": 120,
							"s": [
								70,
								118.5,
								0
							]
						}
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						0,
						0,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [
				{
					"d": 1,
					"ty": "el",
					"s": {
						"a": 0,
						"k": [
							50,
							50
						],
						"ix": 2
					},
					"p": {
						"a": 0,
						"k": [
							0,
							0
						],
						"ix": 3
					},
					"nm": "Ellipse Path 1",
					"mn": "ADBE Vector Shape - Ellipse",
					"hd": false
				},
				{
					"ty": "tm",
					"s": {
						"a": 0,
						"k": 0,
						"ix": 1
					},
					"e": {
						"a": 1,
						"k": [
							{
								"i": {
									"x": [
										0.833
									],
									"y": [
										0.833
									]
								},
								"o": {
									"x": [
										0.333
									],
									"y": [
										0
									]
								},
								"t": 30,
								"s": [
									0
								]
							},
							{
								"i": {
									"x": [
										0.833
									],
									"y": [
										0.833
									]
								},
								"o": {
									"x": [
										0.167
									],
									"y": [
										0.167
									]
								},
								"t": 42,
								"s": [
									100
								]
							},
							{
								"i": {
									"x": [
										0.833
									],
									"y": [
										0.833
									]
								},
								"o": {
									"x": [
										0.167
									],
									"y": [
										0.167
									]
								},
								"t": 75,
								"s": [
									100
								]
							},
							{
								"t": 120,
								"s": [
									100
								]
							}
						],
						"ix": 2
					},
					"o": {
						"a": 0,
						"k": 0,
						"ix": 3
					},
					"m": 1,
					"ix": 2,
					"nm": "Trim Paths 1",
					"mn": "ADBE Vector Filter - Trim",
					"hd": false
				},
				{
					"ty": "st",
					"c": {
						"a": 0,
						"k": [
							0,
							0.1882353127,
							0.341176480055,
							1
						],
						"ix": 3
					},
					"o": {
						"a": 0,
						"k": 100,
						"ix": 4
					},
					"w": {
						"a": 0,
						"k": 3,
						"ix": 5
					},
					"lc": 2,
					"lj": 2,
					"bm": 0,
					"nm": "Stroke 1",
					"mn": "ADBE Vector Graphic - Stroke",
					"hd": false
				}
			],
			"ip": 30,
			"op": 67,
			"st": 30,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 14,
			"ty": 4,
			"nm": "Funnel Mask 2",
			"td": 1,
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						70,
						130,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						70,
						130,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-0.144,
											-0.321
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-0.196,
											-0.202
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-0.342,
											0
										],
										[
											0,
											0
										],
										[
											-0.133,
											0.335
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-0.049,
											0.596
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0.008,
											0.366
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0.118,
											0.262
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0.125,
											0.354
										],
										[
											0,
											0
										],
										[
											0.33,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0.392,
											-0.41
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											60.172,
											-44.235
										],
										[
											-60.194,
											-43.345
										],
										[
											-59.979,
											-30.795
										],
										[
											-59.74,
											-29.756
										],
										[
											-59.746,
											-29.756
										],
										[
											-59.74,
											-29.756
										],
										[
											-59.272,
											-29.05
										],
										[
											-19.086,
											10.259
										],
										[
											-7.264,
											43.649
										],
										[
											-6.489,
											44.236
										],
										[
											4.874,
											44.236
										],
										[
											5.636,
											43.685
										],
										[
											18.948,
											10.259
										],
										[
											59.509,
											-28.981
										],
										[
											60.194,
											-30.542
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									70,
									133.012
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Funnel Shape",
					"np": 1,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "rc",
					"d": 1,
					"s": {
						"a": 0,
						"k": [
							133,
							100
						],
						"ix": 2
					},
					"p": {
						"a": 0,
						"k": [
							70,
							304
						],
						"ix": 3
					},
					"r": {
						"a": 0,
						"k": 0,
						"ix": 4
					},
					"nm": "Rectangle Path 1",
					"mn": "ADBE Vector Shape - Rect",
					"hd": false
				},
				{
					"ty": "fl",
					"c": {
						"a": 0,
						"k": [
							1,
							0,
							0,
							1
						],
						"ix": 4
					},
					"o": {
						"a": 0,
						"k": 100,
						"ix": 5
					},
					"r": 1,
					"bm": 0,
					"nm": "Fill 1",
					"mn": "ADBE Vector Graphic - Fill",
					"hd": false
				}
			],
			"ip": 30,
			"op": 2730,
			"st": 30,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 15,
			"ty": 4,
			"nm": "Dollar Sign",
			"parent": 17,
			"tt": 2,
			"sr": 1,
			"ks": {
				"o": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": [
									0.833
								],
								"y": [
									0.833
								]
							},
							"o": {
								"x": [
									0.167
								],
								"y": [
									0.167
								]
							},
							"t": 30,
							"s": [
								0
							]
						},
						{
							"i": {
								"x": [
									0.2
								],
								"y": [
									1
								]
							},
							"o": {
								"x": [
									0.167
								],
								"y": [
									0
								]
							},
							"t": 67,
							"s": [
								100
							]
						},
						{
							"t": 94,
							"s": [
								100
							]
						}
					],
					"ix": 11
				},
				"r": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": [
									0.833
								],
								"y": [
									0.833
								]
							},
							"o": {
								"x": [
									0.167
								],
								"y": [
									0.167
								]
							},
							"t": 30,
							"s": [
								-172
							]
						},
						{
							"i": {
								"x": [
									0.4
								],
								"y": [
									1
								]
							},
							"o": {
								"x": [
									0.167
								],
								"y": [
									0.167
								]
							},
							"t": 67,
							"s": [
								-172
							]
						},
						{
							"t": 95,
							"s": [
								0
							]
						}
					],
					"ix": 10
				},
				"p": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": 0.833,
								"y": 0.833
							},
							"o": {
								"x": 0.167,
								"y": 0.167
							},
							"t": 30,
							"s": [
								0,
								0.25,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"i": {
								"x": 0.2,
								"y": 1
							},
							"o": {
								"x": 0.167,
								"y": 0.167
							},
							"t": 67,
							"s": [
								0,
								0.25,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"t": 90,
							"s": [
								0,
								-1,
								0
							]
						}
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						70,
						218,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": [
									0.5,
									0.5,
									0.667
								],
								"y": [
									1,
									1,
									1
								]
							},
							"o": {
								"x": [
									0.167,
									0.167,
									0.167
								],
								"y": [
									0,
									0,
									0
								]
							},
							"t": 30,
							"s": [
								6,
								6,
								100
							]
						},
						{
							"i": {
								"x": [
									0.4,
									0.4,
									0.667
								],
								"y": [
									1,
									1,
									1
								]
							},
							"o": {
								"x": [
									0.333,
									0.333,
									0.333
								],
								"y": [
									0,
									0,
									0
								]
							},
							"t": 67,
							"s": [
								6,
								6,
								100
							]
						},
						{
							"t": 90,
							"s": [
								100,
								100,
								100
							]
						}
					],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											-1.427,
											-1.484
										],
										[
											0,
											-2.401
										],
										[
											0,
											0
										],
										[
											1.54,
											-1.315
										],
										[
											2.967,
											-0.198
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											2.232,
											0.537
										],
										[
											0,
											0
										],
										[
											-3.844,
											0
										],
										[
											-0.876,
											0.467
										],
										[
											0,
											1.187
										],
										[
											0,
											0
										],
										[
											0.551,
											0.495
										],
										[
											1.018,
											0
										],
										[
											0,
											0
										],
										[
											1.54,
											1.358
										],
										[
											0,
											3.081
										],
										[
											0,
											0
										],
										[
											-1.456,
											1.427
										],
										[
											-2.854,
											0.226
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-2.686,
											-0.566
										],
										[
											0,
											0
										],
										[
											1.979,
											0
										],
										[
											0.82,
											-0.493
										],
										[
											0,
											-1.328
										],
										[
											0,
											0
										],
										[
											-0.607,
											-0.495
										],
										[
											-1.244,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											1.427,
											1.484
										],
										[
											0,
											0
										],
										[
											0,
											3.138
										],
										[
											-1.541,
											1.314
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-3.165,
											-0.141
										],
										[
											0,
											0
										],
										[
											2.515,
											0.253
										],
										[
											1.723,
											0
										],
										[
											0.876,
											-0.466
										],
										[
											0,
											0
										],
										[
											0,
											-0.933
										],
										[
											-0.552,
											-0.494
										],
										[
											0,
											0
										],
										[
											-3.11,
											0
										],
										[
											-1.541,
											-1.355
										],
										[
											0,
											0
										],
										[
											0,
											-2.769
										],
										[
											1.456,
											-1.428
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											2.46,
											0.114
										],
										[
											0,
											0
										],
										[
											-3.872,
											-0.254
										],
										[
											-1.611,
											0
										],
										[
											-0.819,
											0.495
										],
										[
											0,
											0
										],
										[
											0,
											1.075
										],
										[
											0.607,
											0.493
										],
										[
											0,
											0
										],
										[
											2.713,
											0
										]
									],
									"v": [
										[
											8.416,
											-0.762
										],
										[
											10.557,
											5.067
										],
										[
											10.557,
											6.847
										],
										[
											8.247,
											13.525
										],
										[
											1.484,
											15.792
										],
										[
											1.484,
											19.354
										],
										[
											-2.077,
											19.354
										],
										[
											-2.077,
											15.792
										],
										[
											-10.173,
											14.775
										],
										[
											-10.173,
											9.816
										],
										[
											-0.635,
											10.197
										],
										[
											3.265,
											9.497
										],
										[
											4.579,
											7.018
										],
										[
											4.579,
											5.872
										],
										[
											3.753,
											3.732
										],
										[
											1.4,
											2.99
										],
										[
											-1.271,
											2.99
										],
										[
											-8.244,
											0.954
										],
										[
											-10.557,
											-5.701
										],
										[
											-10.557,
											-7.227
										],
										[
											-8.372,
											-13.522
										],
										[
											-1.908,
											-16.003
										],
										[
											-2.077,
											-18.335
										],
										[
											1.273,
											-19.354
										],
										[
											1.484,
											-16.046
										],
										[
											1.357,
											-16.003
										],
										[
											9.073,
											-14.985
										],
										[
											9.073,
											-10.025
										],
										[
											0.298,
											-10.408
										],
										[
											-3.35,
											-9.665
										],
										[
											-4.577,
											-6.932
										],
										[
											-4.577,
											-6.083
										],
										[
											-3.667,
											-3.729
										],
										[
											-0.889,
											-2.988
										],
										[
											2.206,
											-2.988
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0,
									0.188235309077,
									0.341176470588,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									70.264,
									218.012
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Dollar Sign",
					"np": 2,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				}
			],
			"ip": 30,
			"op": 2730,
			"st": 30,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 16,
			"ty": 4,
			"nm": "Funnel Mask",
			"td": 1,
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						70,
						130,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						70,
						130,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-0.144,
											-0.321
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-0.196,
											-0.202
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-0.342,
											0
										],
										[
											0,
											0
										],
										[
											-0.133,
											0.335
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-0.049,
											0.596
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0.008,
											0.366
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0.118,
											0.262
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0.125,
											0.354
										],
										[
											0,
											0
										],
										[
											0.33,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0.392,
											-0.41
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											60.172,
											-44.235
										],
										[
											-60.194,
											-43.345
										],
										[
											-59.979,
											-30.795
										],
										[
											-59.74,
											-29.756
										],
										[
											-59.746,
											-29.756
										],
										[
											-59.74,
											-29.756
										],
										[
											-59.272,
											-29.05
										],
										[
											-19.086,
											10.259
										],
										[
											-7.264,
											43.649
										],
										[
											-6.489,
											44.236
										],
										[
											4.874,
											44.236
										],
										[
											5.636,
											43.685
										],
										[
											18.948,
											10.259
										],
										[
											59.509,
											-28.981
										],
										[
											60.194,
											-30.542
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									70,
									133.012
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Funnel Shape",
					"np": 1,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "rc",
					"d": 1,
					"s": {
						"a": 0,
						"k": [
							133,
							100
						],
						"ix": 2
					},
					"p": {
						"a": 0,
						"k": [
							70,
							304
						],
						"ix": 3
					},
					"r": {
						"a": 0,
						"k": 0,
						"ix": 4
					},
					"nm": "Rectangle Path 1",
					"mn": "ADBE Vector Shape - Rect",
					"hd": false
				},
				{
					"ty": "fl",
					"c": {
						"a": 0,
						"k": [
							1,
							0,
							0,
							1
						],
						"ix": 4
					},
					"o": {
						"a": 0,
						"k": 100,
						"ix": 5
					},
					"r": 1,
					"bm": 0,
					"nm": "Fill 1",
					"mn": "ADBE Vector Graphic - Fill",
					"hd": false
				}
			],
			"ip": 30,
			"op": 2730,
			"st": 30,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 17,
			"ty": 4,
			"nm": "Dollar Circle",
			"tt": 2,
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": 0.833,
								"y": 0.833
							},
							"o": {
								"x": 0.167,
								"y": 0.167
							},
							"t": 30,
							"s": [
								69.5,
								169,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"i": {
								"x": 0.2,
								"y": 1
							},
							"o": {
								"x": 0.167,
								"y": 0.167
							},
							"t": 67,
							"s": [
								69.5,
								169,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"i": {
								"x": 0.2,
								"y": 0.2
							},
							"o": {
								"x": 0.167,
								"y": 0.167
							},
							"t": 90,
							"s": [
								69.5,
								219,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"t": 95,
							"s": [
								69.5,
								219,
								0
							]
						}
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						0,
						0,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"d": 1,
							"ty": "el",
							"s": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": [
												0.833,
												0.833
											],
											"y": [
												1,
												1
											]
										},
										"o": {
											"x": [
												0.167,
												0.167
											],
											"y": [
												0,
												0
											]
										},
										"t": 30,
										"s": [
											12,
											12
										]
									},
									{
										"i": {
											"x": [
												0.4,
												0.4
											],
											"y": [
												1,
												1
											]
										},
										"o": {
											"x": [
												0.5,
												0.5
											],
											"y": [
												0,
												0
											]
										},
										"t": 67,
										"s": [
											12,
											12
										]
									},
									{
										"i": {
											"x": [
												0.833,
												0.833
											],
											"y": [
												1,
												1
											]
										},
										"o": {
											"x": [
												0.167,
												0.167
											],
											"y": [
												0,
												0
											]
										},
										"t": 90,
										"s": [
											56,
											56
										]
									},
									{
										"t": 95,
										"s": [
											56,
											56
										]
									}
								],
								"ix": 2
							},
							"p": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 3
							},
							"nm": "Ellipse Path 1",
							"mn": "ADBE Vector Shape - Ellipse",
							"hd": false
						},
						{
							"ty": "tm",
							"s": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": [
												0.833
											],
											"y": [
												0.833
											]
										},
										"o": {
											"x": [
												0.167
											],
											"y": [
												0.167
											]
										},
										"t": 30,
										"s": [
											0
										]
									},
									{
										"i": {
											"x": [
												0.667
											],
											"y": [
												1
											]
										},
										"o": {
											"x": [
												0.167
											],
											"y": [
												0
											]
										},
										"t": 67,
										"s": [
											0
										]
									},
									{
										"t": 95,
										"s": [
											0
										]
									}
								],
								"ix": 1
							},
							"e": {
								"a": 0,
								"k": 100,
								"ix": 2
							},
							"o": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": [
												0.833
											],
											"y": [
												0.833
											]
										},
										"o": {
											"x": [
												0.167
											],
											"y": [
												0.167
											]
										},
										"t": 30,
										"s": [
											180
										]
									},
									{
										"i": {
											"x": [
												0.667
											],
											"y": [
												1
											]
										},
										"o": {
											"x": [
												0.167
											],
											"y": [
												0
											]
										},
										"t": 67,
										"s": [
											180
										]
									},
									{
										"t": 95,
										"s": [
											180
										]
									}
								],
								"ix": 3
							},
							"m": 1,
							"ix": 2,
							"nm": "Trim Paths 1",
							"mn": "ADBE Vector Filter - Trim",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 1",
					"np": 2,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "st",
					"c": {
						"a": 0,
						"k": [
							0,
							0.1882353127,
							0.341176480055,
							1
						],
						"ix": 3
					},
					"o": {
						"a": 0,
						"k": 100,
						"ix": 4
					},
					"w": {
						"a": 0,
						"k": 3,
						"ix": 5
					},
					"lc": 2,
					"lj": 2,
					"bm": 0,
					"nm": "Stroke 1",
					"mn": "ADBE Vector Graphic - Stroke",
					"hd": false
				}
			],
			"ip": 30,
			"op": 2730,
			"st": 30,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 18,
			"ty": 4,
			"nm": "Funnel Shape",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						70,
						130,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						70,
						130,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-0.144,
											-0.321
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-0.196,
											-0.202
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-0.342,
											0
										],
										[
											0,
											0
										],
										[
											-0.133,
											0.335
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-0.049,
											0.596
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0.008,
											0.366
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0.118,
											0.262
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0.125,
											0.354
										],
										[
											0,
											0
										],
										[
											0.33,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0.392,
											-0.41
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											60.172,
											-44.235
										],
										[
											-60.194,
											-43.345
										],
										[
											-59.979,
											-30.795
										],
										[
											-59.74,
											-29.756
										],
										[
											-59.746,
											-29.756
										],
										[
											-59.74,
											-29.756
										],
										[
											-59.272,
											-29.05
										],
										[
											-19.086,
											10.259
										],
										[
											-7.264,
											43.649
										],
										[
											-6.489,
											44.236
										],
										[
											4.874,
											44.236
										],
										[
											5.636,
											43.685
										],
										[
											18.948,
											10.259
										],
										[
											59.509,
											-28.981
										],
										[
											60.194,
											-30.542
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									0,
									0.188235309077,
									0.341176470588,
									1
								],
								"ix": 3
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 4
							},
							"w": {
								"a": 0,
								"k": 3,
								"ix": 5
							},
							"lc": 2,
							"lj": 2,
							"bm": 0,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									70,
									133.012
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Funnel Shape",
					"np": 2,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											10.254,
											103.256
										],
										[
											129.51,
											103.256
										]
									],
									"c": false
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									0,
									0.188235309077,
									0.341176470588,
									1
								],
								"ix": 3
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 4
							},
							"w": {
								"a": 0,
								"k": 3,
								"ix": 5
							},
							"lc": 2,
							"lj": 2,
							"bm": 0,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Line 1",
					"np": 2,
					"cix": 2,
					"bm": 0,
					"ix": 2,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											50.914,
											143.271
										],
										[
											88.948,
											143.271
										]
									],
									"c": false
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									0,
									0.188235309077,
									0.341176470588,
									1
								],
								"ix": 3
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 4
							},
							"w": {
								"a": 0,
								"k": 3,
								"ix": 5
							},
							"lc": 2,
							"lj": 2,
							"bm": 0,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Line 2",
					"np": 2,
					"cix": 2,
					"bm": 0,
					"ix": 3,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "tm",
					"s": {
						"a": 0,
						"k": 0,
						"ix": 1
					},
					"e": {
						"a": 1,
						"k": [
							{
								"i": {
									"x": [
										0.4
									],
									"y": [
										1
									]
								},
								"o": {
									"x": [
										0.333
									],
									"y": [
										0
									]
								},
								"t": 0,
								"s": [
									0
								]
							},
							{
								"t": 30,
								"s": [
									100
								]
							}
						],
						"ix": 2
					},
					"o": {
						"a": 0,
						"k": 0,
						"ix": 3
					},
					"m": 2,
					"ix": 4,
					"nm": "Trim Paths 1",
					"mn": "ADBE Vector Filter - Trim",
					"hd": false
				}
			],
			"ip": 0,
			"op": 2730,
			"st": 30,
			"bm": 0
		}
	],
	"markers": []
};


//////////////////
// WEBPACK FOOTER
// ./frontend/pages/LiveMarkets/animations/funnelSpot/Funnel_Spot_NoLoop_01.json
// module id = 648
// module chunks = 0